// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"232fff03","74":"b4295f6e","229":"2f7c9859","230":"4d427a03","365":"d319334d","453":"a3c1d153","551":"81b48f6c","617":"501a7485","849":"13b7bdd2","851":"c2809901","940":"9793e18b"}[chunkId] + ".chunk.js";
};